import { CreatedByRelationship } from './Common'

export const organizationTeamMemberMapSF = {
  direction: 'in',
  ...CreatedByRelationship,
  Id: 'id',
  UserId: 'userId',
  TeamMemberRole: 'teamMemberRole',
  AccountAccessLevel: 'accessLevel',
  AccountId: 'accountId',
  Title__c: 'title',
  User: {
    key: 'user',
    in: obj => {
      return {
        email: obj.User.Email,
        name: obj.User.Name
      }
    }
  }
}

export type OrganizationTeamMemberRole = 'Manager' | 'Contributor' | 'Operator' | 'Selection Committee Member'
export interface OrganizationTeamMember {
  id: string
  teamMemberRole: OrganizationTeamMemberRole
  userId: string
  accessLevel: string
}
